
import React from 'react';
import './index.scss';
import emailIcon from '../../assets/email.png';
import successIcon from '../../assets/v1.png';
import { Dialog } from '../../components/Dialog';
import * as api from '../../services/api';
import en from '../../locales/en-US.json';
import zh from '../../locales/zh-Hans.json';
import urlparser from 'urlparser';
import { Helmet } from 'react-helmet';
import { IWeChatProps } from '../Wechat';
import ReactGA from 'react-ga';

interface IProps {
}

interface IState {
  errMsg: string;
  showErr: boolean;
  email: string;
  lang: string;
  showDialog: boolean;
  message: any;
  jwt: string;
  time: string;
  custom: any;
  title: string;
  disabled: boolean;
  isWeChat: string;
  buttonUrl: string;
  logo: string;
  inviterId: string;
  qrcode:string;
  trailId:string;
  state:string;
}

interface IParams {
  jwt: string;
  isWeChat: string;
  weChatButtonUrl: string;
  logo: string;
  inviterId:string;
  qrcode:string;
}

export interface ITrialRes {
  time: number;
  error?: string;
  body?: {
    days: number;
  };
}

export class WeChatSuccess extends React.Component<IWeChatProps, IState> {
  public readonly state: Readonly<IState> = {
    errMsg: '',
    showErr: false,
    email: '',
    lang: 'zh-Hans',
    showDialog: false,
    message: {
      'zh-Hans': zh,
      'en-US': en
    },
    jwt: '',
    time: '',
    custom: '',
    title: '',
    disabled: false,
    isWeChat: '',
    buttonUrl: '',
    logo: '',
    qrcode:'',
    inviterId: '',
    trailId:'',
    state:''
  };

  UNSAFE_componentWillMount() {
    let url = urlparser.parse(window.location.href);
    let path = url.path.base;
    if (path.split('/')[1] === 'en') {
      this.setState({
        lang: 'en-US'
      });
    }
    let title = '';
    switch (path) {
      case 'trial/activity':
      case 'trial/activity-kw':
        title = 'iSlide VIP体验活动';
        break;
      case 'trial/bookActivity':
        title = 'iSlide 书籍活动';
        break;
      default:
        title = 'iSlide VIP体验活动';
        break;
    }
    this.setState({
      title
    });

    if (path === 'trial/activity-kw') {
      let custom = require('../../assets/kw.png');
      this.setState({
        custom
      });
    }
  }

  componentDidMount() {
    this.setState(
      {
        trailId:this.props.trailId,
        logo: this.props.logo,
        inviterId:this.props.inviterId,
        qrcode:this.props.qrcode,
        state:this.props.state
      });
  }

  handleEmailChange(e: React.ChangeEvent<HTMLInputElement>) {
    this.setState({
      email: e.target.value
    });
  }

  async handleSubmit() {
    if (!this.state.email.trim()) {
      return this.setState({
        errMsg: '邮箱必填',
        showErr: true
      });
    }

    this.setState({
      disabled: true
    });

    let result: ITrialRes = await api.register(
      this.state.jwt,
      this.state.trailId,
      this.state.email.trim(),
      this.state.state
    );
    if (result.error) {
      return this.setState({
        disabled: false,
        errMsg: result.error,
        showErr: true
      });
    }
    if (result.body) {
      ReactGA.pageview(window.location.pathname+`/${result.body.days}days/email/success`);
      this.setState({
        time: `${result.body.days}`,
        showDialog: true
      });
    }
  }

  handleWechat = () => {
    if (!this.state.buttonUrl) {
      return;
    }
    // window.location.href = this.state.buttonUrl;
    window.open(this.state.buttonUrl);
  };

  render() {
    return (
      <div id="success-page">
        <Helmet>
          <title>{this.state.title}</title>
        </Helmet>
        <section id="header">
          {/*{this.state.custom ? (*/}
          <div className="custom">
            {this.state.logo ? <img src={this.state.logo} alt=""/> : this.state.custom ?
              <img src={this.state.custom} alt=""/> : null}
          </div>
          {/*) : null}*/}
          <h1 className="title">为您节省90%的PPT设计时间</h1>
          <p className="description">30+万专业级模版一键导入PPT</p>
        </section>
        <section id="form">
          {/*{*/}
          {/*  this.state.isWeChat === '1'*/}
          {/*    ?*/}
          {/*    <div className="weChatShare">*/}
          {/*      <img src={require('../../assets/wechatQrcode.jpg')} alt=""/>*/}
          {/*      <p>长按二维码关注iSlide</p>*/}
          {/*      <p>获取专属优惠</p>*/}
          {/*    </div>*/}
          {/*    :*/}
          <div className="form">
            <p className="err-message">{this.state.errMsg}</p>
            <div className="form-input">
              <img className="email-icon" src={emailIcon} alt="email"/>
              <input
                onChange={this.handleEmailChange.bind(this)}
                placeholder="填写邮箱获取iSlide VIP会员"
              />
            </div>
            <button
              onClick={this.handleSubmit.bind(this)}
              disabled={this.state.disabled}
            >
              立即体验
            </button>
          </div>
          {/*}*/}

        </section>
        <Dialog
          visible={this.state.showDialog}
          onClose={() => {
            this.setState({
              showDialog: false,
              disabled: false
            });
          }}
        >
          <div className="dialog-success">
            <img src={successIcon} alt="success"/>
            <p className="message">账号开通成功!</p>
            <section className="footer">
              <p className="remark">您的体验会员时长为{this.state.time}天，请及时登录使用</p>
              <p className="remark" style={{ marginTop: '0.2rem' }}>
                请查收以便于及时激活您的账号
              </p>
              <p className="remark" style={{ marginBottom: '0.4rem' }}>
                (可能误判为垃圾邮件)
              </p>
            </section>
          </div>
        </Dialog>
      </div>
      //{' '}
    );
  }
}
